import { setPrismMenu } from 'actions/ui';
import PageHeader from 'components/general/pageHeader';
import { Loading, SystemText, DebugInfo } from '@salesperformanceint/e4shared';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pathway from 'components/prism/pathway';
import PathwayCard from 'components/prism/pathwayCard';
import { apiGet } from 'services';
import Subheader from 'components/prism/subheader';
import NoResults from 'components/prism/noResults';
import { isFuture } from 'helpers/dates';

export const Pathways = () => {
    const dispatch = useDispatch();
    const [data, setData] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const { user } = useSelector(state => state.user);
    const { prismMultiColumn } = useSelector(state => state.ui);

    const text = React.useMemo(
        () => ({
            title: SystemText('PathwaysLibrary/Title'),
            active: SystemText('PathwaysLibrary/Active'),
            completed: SystemText('PathwaysLibrary/Completed'),
            noResults: SystemText('PathwaysLibrary/NoResults/Title'),
            noResultsSummary: SystemText('PathwaysLibrary/NoResults/Summary'),
        }),
        [user]
    );

    React.useEffect(() => {
        dispatch(setPrismMenu('Pathways'));
    }, []);

    React.useEffect(() => {
        if (user) {
            apiGet('pathway-library', user.guid, response => {
                setData({
                    active: response.filter(x => {
                        if (x.completed) return false;
                        // Only show if launch date has passed
                        if (x.launch) {
                            return !isFuture(x.launch);
                        }

                        // If no launch date, show it
                        return true;
                    }),
                    completed: response.filter(x => x.completed),
                });

                setLoading(false);
            });
        }
    }, [user]);

    React.useEffect(() => {
        DebugInfo('component', 'Pathways');
    }, []);
    return (
        <div id="pathways-page" data-testid="pathways-page">
            <PageHeader title={text.title} />
            <section className="content">
                {loading ? (
                    <Loading />
                ) : (
                    <div>
                        <Subheader title={text.active} count={data?.active.length} />
                        {data?.active.length === 1 ? (
                            <PathwayCard pathway={data.active[0]} />
                        ) : data?.active.length > 1 ? (
                            <div className={prismMultiColumn ? 'even-col' : ''}>
                                {data?.active.map(item => (
                                    <Pathway key={`pathway-${item.id}`} padBottom={!prismMultiColumn} item={item} />
                                ))}
                            </div>
                        ) : (
                            <NoResults icon="route" title={text.noResults} summary={text.noResultsSummary} />
                        )}
                        {data?.completed.length > 0 && (
                            <div className="mt30">
                                <Subheader title={text.completed} count={data?.completed.length} />
                                <div className={prismMultiColumn ? 'even-col' : ''}>
                                    {data?.completed.map(item => (
                                        <Pathway key={`pathway-${item.id}`} padBottom={!prismMultiColumn} item={item} />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </section>
        </div>
    );
};

export default Pathways;
